import script from "./ShowImagesForTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowImagesForTask.vue?vue&type=script&setup=true&lang=js"

import "./ShowImagesForTask.vue?vue&type=style&index=0&id=336765ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336765ff"]])

export default __exports__